<script>
    import { onMount } from 'svelte';
    import { checkOneUserResetCode, updateUserPassword } from '/public/services/User.js';
    import { navigateTo } from 'svelte-router-spa';
    import { fade,slide } from 'svelte/transition';
    import PasswordStrength from "svelte-password-strength-bar";

    export let currentRoute;

    let hash = currentRoute.namedParams.hash;
    let loading = true;
    let user = null;
    let updating = false;

    let pw = null;
    let pwc = null;
    let doesMatch = true;
    let updateSuccess = false;

    function checkHash() {
        checkOneUserResetCode(hash).then(res => {
            if (res.success) {
                user = res.data.user;
                loading = false;
            } else {
                navigateTo('/');
            }
        });
    }

    function updateOneUserPassword(e) {        
        e.preventDefault();

        updateSuccess = false;

        if (pw != pwc) {
            doesMatch = false;
            return;
        } else {
            doesMatch = true;
        }

        updateUserPassword(hash, {password: pw}).then(res => {
            if (res.success) {
                pw = null;
                pwc = null;
                updateSuccess = true;
            }
        });
    }

    onMount(() => {
        checkHash();
    });

</script>
{#if loading === true}

    <div class='text-center mt-5 mb-5'>
        <h4>
            <span class='ajax-ball-loader'></span> Checking your reset code....
        </h4>
    </div>

{:else}

    <section in:fade>
        <div class='row justify-content-center'>
            <div class='col-sm-12 col-md-10 col-lg-8'>
                <div class='card mb-3'>
                    <div class='card-header'>
                        <span class='fas fa-lock-open'></span> Reset your password
                    </div>
                    <div class='card-body'>

                        {#if updateSuccess === false}

                            {#if updating === true}

                                <div class='text-center mt-5 mb-5'>
                                    <h4>
                                        <span class='ajax-ball-loader'></span> Updating your password....
                                    </h4>
                                </div>

                            {:else}                            

                                <form class="form" on:submit={updateOneUserPassword}>
                                    <div class="row mb-3">
                                        <label class="col-sm-3 col-form-label" for="password">
                                            Password
                                        </label>
                                        <div class="col-sm-9">
                                            <input id="password" type="password" bind:value={pw} class="form-control" placeholder="Enter password - min 8 chars" required/>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <label class="col-sm-3 col-form-label" for="password_confirmation">
                                            Password Confirmation
                                        </label>
                                        <div class="col-sm-9">
                                            <input id="password_confirmation" type="password" bind:value={pwc} class="form-control" placeholder="And again" required/>
                                        </div>
                                    </div>

                                    {#if pw != null}

                                        <div class='row mb-3' in:slide>
                                            <label class='col-form-label col-sm-3' for='strength'>
                                                Password Strength
                                            </label>
                                            <div class='col-sm-9'>
                                    
                                                <PasswordStrength password={pw}/>
                                    
                                            </div>
                                        </div>

                                    {/if}

                                    {#if doesMatch === false}

                                        <div class="row mb-3" in:slide out:slide>
                                            <div class="col-sm-9 offset-sm-3">
                                                <div class="alert bg-warning">
                                                    <span class="fas fa-exclamation-triangle"></span> The passwords do not match!
                                                </div>
                                            </div>
                                        </div>

                                    {/if}

                                    <div class="row mb-3">
                                        <div class="col-sm-9 offset-sm-3">
                                            <button type="submit" class="btn btn-primary">
                                                <span class="fas fa-save"></span> Update Password
                                            </button>
                                        </div>
                                    </div>
                                </form>

                            {/if}

                        {:else}

                            <section in:slide>
                                <div class='alert alert-success clearfix mb-3'>
                                    <h4 class='float-start me-3'>
                                        <span class='fas fa-check-circle'></span>
                                    </h4>
                                    Your password has been successfully updated.
                                </div>
                                <div class='text-center mt-3 mb-3'>
                                    <a href='/login' class='btn btn-outline-primary'>
                                        <span class='fas fa-chevron-left'></span> Login
                                    </a>
                                </div>
                            </section>

                        {/if}

                    </div>
                </div>
            </div>
        </div>
    </section>

{/if}